function ReverseRangeFilter() {
  return function (input, min, max) {
    min = parseInt(min, 10); //Make string input int
    max = parseInt(max, 10);
    for (let i = min; i < max; i++) //eslint-disable-line
      input.push(i);
    return input.reverse();
  };
}

ReverseRangeFilter.$inject = [];

export default ReverseRangeFilter;



// WEBPACK FOOTER //
// ./src/filters/reverseRangeFilter.js